export default "__VITE_ASSET__B47s71A3__"